module.exports = __webpack_public_path__ + "media/images/icons/aandp_icon-5e52832dc2e82952554b4fc910f7f6c1.svg";